import Script from "next/script";

export const GoogleTagManager = () => {
	return (
		<>
			<Script
				id="google-tag-manager"
				dangerouslySetInnerHTML={{
					__html: `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PBMMB6RH');
`,
				}}
			/>

			<noscript>
				<iframe
					src="https://www.googletagmanager.com/ns.html?id=GTM-PBMMB6RH"
					style={{ height: 0, width: 0, display: "none", visibility: "hidden" }}
				/>
			</noscript>
		</>
	);
};
